import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { REGEX } from '@shared/utils/regex.constants';

export type TutorChangeEmailDialogData = {
  email?: string | null;
};

export type TutorChangeEmailDialogResult = {
  email: string;
};

@Component({
  selector: 'app-tutor-change-email-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ],
  templateUrl: './tutor-change-email-dialog.component.html',
  styleUrl: './tutor-change-email-dialog.component.scss'
})
export class TutorChangeEmailDialogComponent {
  emailCtrl = new FormControl<string>(
    (this.data?.email ?? '').trim().toLowerCase(),
    {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(REGEX.correo)]
    }
  );

  constructor(
    private ref: MatDialogRef<TutorChangeEmailDialogComponent, TutorChangeEmailDialogResult | null>,
    @Inject(MAT_DIALOG_DATA) public data: TutorChangeEmailDialogData
  ) {}

  cancelar(): void {
    this.ref.close(null);
  }

  aceptar(): void {
    if (this.emailCtrl.invalid) {
      this.emailCtrl.markAsTouched();
      return;
    }
    this.ref.close({ email: this.emailCtrl.value.trim().toLowerCase() });
  }
}
